export function parseBoolean(str) {
    switch (str) {
        case "TRUE":
        case "true":
            return true;
        case "FALSE":
        case "false":
            return false;
    }
}
//# sourceMappingURL=parseBoolean.js.map